module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/spices_720193.jpg";